import { render } from "./GeneralDocumentManager.vue?vue&type=template&id=3525740d"
import script from "./GeneralDocumentManager.vue?vue&type=script&lang=js"
export * from "./GeneralDocumentManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__